/**
 * @module M/plugin/ReferenceLocatorCatastro
 */
import 'assets/css/fonts';
import 'assets/css/referencelocatorcatastro';
import ReferenceLocatorCatastroControl from './referencelocatorcatastrocontrol';
import api from '../../api';
import { getValue } from './i18n/language';

import es from './i18n/es';
import en from './i18n/en';

export default class ReferenceLocatorCatastro extends M.Plugin {
  /**
   * @classdesc
   * Main facade plugin object. This class creates a plugin
   * object which has an implementation Object
   *
   * @constructor
   * @extends {M.Plugin}
   * @param {Object} impl implementation object
   * @api stable
   */
  constructor(options = {}) {
    super();

    /**
     * Facade of the map
     * @private
     * @type {M.Map}
     */
    this.map_ = null;

    /**
     * Array of controls
     * @private
     * @type {Array<M.Control>}
     */
    this.controls_ = [];

    /**
     * Position of the plugin
     * @private
     * @type {String}
     */
    this.position_ = options.position || 'TR';

    /**
     * Option to allow the plugin to be collapsed or not
     * @private
     * @type {Boolean}
     */
    this.collapsed_ = options.collapsed;
    if (this.collapsed_ === undefined) this.collapsed_ = true;

    /**
     * Option to allow the plugin to be collapsible or not
     * @private
     * @type {Boolean}
     */
    this.collapsible_ = options.collapsible;
    if (this.collapsible_ === undefined) this.collapsible_ = true;

    /**
     * RCCOOR_url
     * @private
     * @type {String}
     */
    const defectRCCOOR = 'http://ovc.catastro.meh.es/ovcservweb/OVCSWLocalizacionRC/OVCCoordenadas.asmx/Consulta_RCCOOR';
    this.RCCOOR_url = options.RCCOOR_url != null ? options.RCCOOR_url : defectRCCOOR;

    /**
     * CPMRC_url
     * @private
     * @type {String}
     */
    const defectCPMRC = 'http://ovc.catastro.meh.es/INSPIRE/wfsCP.aspx?service=wfs&version=2&request=getfeature&STOREDQUERIE_ID=GetParcel&refcat=*&srsname=EPSG::3857';
    this.CPMRC_url = options.CPMRC_url != null ? options.CPMRC_url : defectCPMRC;

    /**
     * Name of the plugin
     * @private
     * @type {String}
     */
    this.name_ = 'referencelocatorcatastro';

    /**
     * Metadata from api.json
     * @private
     * @type {Object}
     */
    this.metadata_ = api.metadata;
  }

  /**
   * Return plugin language
   *
   * @public
   * @function
   * @param {string} lang type language
   * @api stable
   */
  static getJSONTranslations(lang) {
    if (lang === 'en' || lang === 'es') {
      return (lang === 'en') ? en : es;
    }
    return M.language.getTranslation(lang).referencelocatorcatastro;
  }

  /**
   * This function adds this plugin into the map
   *
   * @public
   * @function
   * @param {M.Map} map the map to add the plugin
   * @api stable
   */
  addTo(map) {
    this.map_ = map;
    this.panel_ = new M.ui.Panel('panelReferenceLocatorCatastro', {
      className: 'm-catastro',
      collapsed: this.collapsed_,
      collapsible: this.collapsible_,
      position: M.ui.position[this.position_],
      collapsedButtonClass: 'icon-infocatastro',
      tooltip: getValue('tooltip'),
    });

    this.controls_.push(new ReferenceLocatorCatastroControl({ RCCOOR_url: this.RCCOOR_url, CPMRC_url: this.CPMRC_url }));
    // map.areasContainer.querySelector('.m-top.m-right').classList.add('top-extra');
    this.panel_.on(M.evt.ADDED_TO_MAP, (html) => {
      M.utils.enableTouchScroll(html);
    });

    this.panel_.addControls(this.controls_);
    map.addPanels(this.panel_);
    // eslint-disable-next-line no-underscore-dangle
    const _this = this;
    this.controls_[0].on(M.evt.ADDED_TO_MAP, () => {
      _this.fire(M.evt.ADDED_TO_MAP);
    });
  }

  /**
   * This function destroys this plugin
   *
   * @public
   * @function
   * @api stable
   */
  destroy() {
    this.map_.removeControls(this.controls_);
    [this.map_, this.controls_, this.panel_] = [null, null, null];
  }

  /**
   * Get the API REST Parameters of the plugin
   *
   * @function
   * @public
   * @api
   */
  getAPIRest() {
    return `${this.name_}=${this.position_}*${this.collapsed_}*${this.collapsible_}`;
  }

  /**
   * This functions gets results layer
   * @public
   * @function
   * @api
   */
  getResultsLayer() {
    return this.controls_[0].getLayer();
  }

  /**
   * This function gets metadata plugin
   *
   * @public
   * @function
   * @api stable
   */
  getMetadata() {
    return this.metadata_;
  }
}
